import { datadogRum } from '@datadog/browser-rum';
import React from 'react';

interface ILinkRegexpMatch {
  link: string;
  relMatch: RegExpMatchArray | null;
  hrefLangMatch: RegExpMatchArray | null;
  hrefMatch: RegExpMatchArray | null;
}
export function createLinkElements(hrefLinks?: readonly string[], defaultHrefLink?: string) {
  const links = addDefaultToArray(hrefLinks, defaultHrefLink);

  if (!links?.length) return null;

  return links.reduce((acc, link) => {
    const linkData = {
      link,
      relMatch: link.match(/rel="([^"]+)"/),
      hrefLangMatch: link.match(/href[lL]ang="([^"]+)"/i),
      hrefMatch: link.match(/href="([^"]+)"/),
    };

    if (!isValidHreflangLink(linkData)) return acc;

    const { relMatch, hrefLangMatch, hrefMatch } = linkData;

    if (!relMatch || !hrefLangMatch || !hrefMatch) return acc;

    const linkComponent = (
      <link key={link} rel={relMatch[1]} hrefLang={hrefLangMatch[1]} href={hrefMatch[1]} />
    );

    return [...acc, linkComponent];
  }, []);
}

function isValidHreflangLink(linkRegexpMatch: ILinkRegexpMatch) {
  const { relMatch, hrefLangMatch, hrefMatch, link } = linkRegexpMatch;
  if (!relMatch || !hrefLangMatch || !hrefMatch) {
    datadogRum.addError(new Error(`Invalid hreflang link: ${link}`));
    return false;
  }
  return true;
}

function addDefaultToArray(
  hrefLinks?: ReadonlyArray<string>,
  defaultHrefLink?: string,
): ReadonlyArray<string> {
  if (!defaultHrefLink) return hrefLinks || [];
  if (!hrefLinks) return [defaultHrefLink];
  return [...hrefLinks, defaultHrefLink];
}
